import { render } from "./Certification.m.backup.vue?vue&type=template&id=db49f348"
import script from "./Certification.m.backup.vue?vue&type=script&lang=js"
export * from "./Certification.m.backup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__